import React from 'react';

import { LoginForm } from './LoginForm';
import { LoginTypography } from './LoginTypography';

function reload() {
  window.location.reload();
}

export function ErrorForm() {
  return (
    <LoginForm autoFocusSubmit submitText="Reload Page" onSubmit={reload}>
      <LoginTypography>
        We&apos;re sorry, but an unexpected error occurred. Please contact help@paragontruss.com.
      </LoginTypography>
    </LoginForm>
  );
}
